// Renders its children into #print-root (a sibling of #root, see
// index.html) instead of in place. Printing a single element buried deep
// in an SPA by hiding everything else with `visibility: hidden` (the
// previous approach) leaves the rest of the page's normal-flow height
// intact -- invisible content still occupies space -- so the print engine
// paginates the WHOLE document's height, producing extra blank pages past
// wherever the one visible island happened to end. A portal sidesteps that
// entirely: `@media print` hides #root outright (display: none removes an
// element's descendants from layout completely, unlike visibility), and
// only #print-root's own, much shorter natural height gets paginated.
import { createPortal } from "react-dom";

export function PrintPortal({ children }) {
  const target = typeof document !== "undefined" ? document.getElementById("print-root") : null;
  if (!target) return null;
  return createPortal(<div>{children}</div>, target);
}
